import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import './CSS/Auth.css';
import { MicrosoftAuth } from '../../Services/MicrosoftAuth';
import { GoogleAuth } from '../../Services/GoogleAuth';
import { EmailAuth } from "../../Services/EmailAuth";

import microsoftLogo from '../../Assets/Images/ms-symbollockup_mssymbol_19.png';
import {GoogleLogin, GoogleOAuthProvider} from "@react-oauth/google";

const Login: React.FC = () => {

    const navigate = useNavigate();

    const { handleInteractiveSignIn, authError: microsoftAuthError } = MicrosoftAuth();
    const { handleGoogleSignIn, authError: googleAuthError } = GoogleAuth();
    const { handleEmailSignin } = EmailAuth();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    useEffect(() => {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn === 'true') {
            navigate('/account/subscription');
        }
    }, [navigate]);


    const handleMicrosoftLogin = async (event: React.MouseEvent) => {
        event.stopPropagation();
        const success = await handleInteractiveSignIn();
        if (success) {
            localStorage.setItem('isLoggedIn', 'true');
            navigate('/account/subscription');
        } else {
            console.error('Microsoft login failed:', microsoftAuthError);
        }
    };

    const handleGoogleClick = (event: React.MouseEvent) => {
        event.stopPropagation();
    };


    return (
            <div className="signin-container">
                <div className="content-area">
                    <h2 className="title">Sign in</h2>

                    <div className="signin-buttons">
                        <button className="signin-button" onClick={handleMicrosoftLogin}>
                            <img src={microsoftLogo} alt="teams logo"/>
                            <span>Sign in with Microsoft</span>
                        </button>

                        <div onClick={handleGoogleClick}>
                            <GoogleOAuthProvider clientId="932661471954-fcbfretcbo2hcf4iivmmfcqji9g08443.apps.googleusercontent.com">
                                <GoogleLogin
                                    onSuccess={async (credentialResponse) => {
                                        const success = await handleGoogleSignIn(credentialResponse);
                                        if (success) {
                                            localStorage.setItem('isLoggedIn', 'true');
                                            navigate('/account/profile');
                                        } else {
                                            console.error('Google login failed:', googleAuthError);
                                        }
                                    }}
                                    onError={() => console.error('Google login failed')}
                                />
                            </GoogleOAuthProvider>
                        </div>
                    </div>

                    {/*<p className="divider">Or sign in with email*/}
                    {/*    <hr/>*/}
                    {/*</p>*/}

                    {/*/!* Sign Up Link *!/*/}
                    {/*<p className="signup-text">*/}
                    {/*    New to VIZEdi?{' '}*/}
                    {/*    <Link to="/Signup" className="signup-link">*/}
                    {/*        Create an Account*/}
                    {/*    </Link>*/}
                    {/*</p>*/}

                    <p className="terms-text">
                        By signing in, you agree to our
                        <br/>
                        <Link to="/terms-of-service" className="signup-link">
                            Terms of Service
                        </Link>
                        {' '}and{' '}
                        <Link to="/privacy-policy" className="signup-link">
                            Privacy Policy
                        </Link>
                    </p>
                </div>
            </div>
    );
};

export default Login;
